import Vue from 'vue';
import docPage from './DocAllPages';
export default Vue.extend(docPage("QuickStart"))
